export default "__VITE_PUBLIC_ASSET__599a8c65__"